/** @module SiteAdmin/Locale/BaseRendererForDateTime */
define([
	"dojo/_base/declare",
	"csi/heading/String",
	"csi/locale",
	"./util"
], function(declare,StringRen,locale,util) {

	return declare(StringRen, {

		/** @property {string} dateTimeSelector - either date or time to render*/
		dateTimeSelector: "",

		/** @property {string} invalidDateTimeResource - either InvalidDateFormatException or InvalidTimeFormatException */
		invalidDateTimeResource: "",

		/**
		 * show the tooltip if the pattern has been change 
		 */
		toTooltip: function(ctx, h, tooltip) {
			var pattern = this._getValue(ctx, h);
			util.addTooltipAsNeeded(ctx, tooltip, pattern, this.dateTimeSelector);
			return this.inherited(arguments);
		},

		/**
		 * Validate the pattern to make sure it's correct before saving
		 */
		validateValue: function(ctx, h, value) {
			try {
				util.getDateTimeFormatBasedOnLocale(ctx.getNodeParent(), this.dateTimeSelector, value);
			} catch(ex) {
				ex.message = locale.resource(this.invalidDateTimeResource);
				throw ex;
			}
		},

		/**
		 * Render value with grey background if it's default pattern
		 */
		_getRenderCSS: function(ctx, h) {
			var css = this.inherited(arguments);
			return util.getDateTimeRenderCss(ctx, this.dateTimeSelector, css);
		},
	});
});